/**
 * 序列化URL的参数
 * **/
export function queryUrl(url) {
    let result = {},
        arr,
        str,
        key,
        key_arr,
        len;
    if (url.indexOf("?") !== -1) {
        arr = url.split("?");
        str = arr[1];
        arr = str.split("&");
        len = arr.length;
        if (len > 0) {
            for (let i = 0; i < len; i++) {
                key = arr[i];
                key_arr = key.split("=");
                result[key_arr[0]] = key_arr[1];
            }
        }
    }
    return result;
}
/**
 * 数字千分位 格式化
 * **/
export function formatNumber(num) {

    if (isNaN(num)) {
        throw new TypeError("num is not a number");
    }
    return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}
/*
* 是否是ios
* */
export function isIOS() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}
/*
* 是否是android
* */
export function isAndroid() {
    return !!(navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1)
}
